import { GlobalStyles as MuiGlobalStyles } from '@mui/material'

const GlobalStyles = () => (
  <MuiGlobalStyles
    styles={{
      // See: https://gomakethings.com/hidden-content-for-better-a11y/#hiding-the-link
      '.screen-reader': {
        border: '0',
        clip: 'rect(0 0 0 0)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '0',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px',
        '&:active, &:focus': {
          clip: 'auto',
          height: 'auto',
          margin: '0',
          overflow: 'visible',
          position: 'static',
          whiteSpace: 'normal',
          width: 'auto',
        },
      },
    }}
  />
)

export default GlobalStyles
